import { Link } from "react-router-dom";
import aboutImg from "../assets/landing/consultation-signing.jpeg";

export default function AboutSection() {
  return (
    <section className="cl-about-v2" id="about">
      <div className="cl-container cl-aboutv2-grid">
        {/* Left: Image */}
        <div className="cl-aboutv2-media">
          <img src={aboutImg} alt="A client signing documents during a legal consultation" />
        </div>

        {/* Right: Text */}
        <div className="cl-aboutv2-content">
          <p className="cl-eyebrow">About Us</p>

          <h2 className="cl-aboutv2-title">
            Legal Support,<br /> Made Simpler.
          </h2>

          <p className="cl-aboutv2-body">
            Click Law is a technology-enabled legal solutions platform designed to make access to
            professional legal support simpler, more convenient, and more affordable.
          </p>
          <p className="cl-aboutv2-body">
            We connect individuals and businesses with qualified, licensed legal professionals and
            law firms based on their legal needs — without the complexity of navigating the legal
            landscape on their own.
          </p>

          <Link to="/contact" className="btn btn-about-outline">
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}
